$bog_ui_app_command $mol_page
	title \Command Palette
	body /
		<= Description $mol_view
			sub /
				<= description \Command palette for quick search and action execution. Press the button or use ⌘K / Ctrl+K to open. Type to filter commands in real time.
		<= Open_title $mol_view
			sub /
				<= open_title \Open palette
		<= Open_row $mol_view
			sub /
				<= Open_button $mol_button_minor
					click? <=> open_palette? null
					sub /
						<= open_label \Open Command Palette
				<= Shortcut_hint $mol_view
					sub /
						<= shortcut_hint \⌘K
		<= Groups_title $mol_view
			sub /
				<= groups_title \Demo commands
		<= Groups_desc $mol_view
			sub /
				<= groups_desc \The palette contains 3 groups: Navigation, Actions, and Settings. Use the search field to filter by command name.
		<= Palette $bog_ui_command
			showed? <=> palette_showed? false
			commands <= demo_commands /
				<= Nav_group $bog_ui_command_group
					title \Navigation
				<= Nav_home $bog_ui_command_item
					label \Go to Home
					shortcut \⌘H
				<= Nav_dashboard $bog_ui_command_item
					label \Go to Dashboard
					shortcut \⌘D
				<= Nav_settings $bog_ui_command_item
					label \Go to Settings
					shortcut \⌘,
				<= Nav_profile $bog_ui_command_item
					label \Go to Profile
				<= Actions_group $bog_ui_command_group
					title \Actions
				<= Actions_new $bog_ui_command_item
					label \Create New Item
					shortcut \⌘N
				<= Actions_save $bog_ui_command_item
					label \Save Current
					shortcut \⌘S
				<= Actions_export $bog_ui_command_item
					label \Export as PDF
					shortcut \⌘⇧E
				<= Settings_group $bog_ui_command_group
					title \Settings
				<= Settings_theme $bog_ui_command_item
					label \Toggle Dark Mode
					shortcut \⌘⇧T
				<= Settings_lang $bog_ui_command_item
					label \Change Language
				<= Settings_notifications $bog_ui_command_item
					label \Notification Settings
